import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid, MenuItem, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { FormGroup } from '../../../../form/FormGroup'
import { ControlledTextField } from '../../../../form/ControlledTextField'
import { validators } from '../../../../../validation/validators'
import { powerUnit } from '../../../../../util/formatters'
import { PerformanceTableFragment } from '../../../../../generated/graphql'
import { InternalFormValues } from '../../form-values'
import { ControlledCheckbox } from '../../../../form/ControlledCheckbox'

type Props = {
  performanceTables: PerformanceTableFragment[]
}

export function CommonOptions({
  performanceTables,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const { control, errors } = useFormContext<InternalFormValues>()

  return (
    <>
      <FormGroup>
        <Grid container spacing={2}>
          <Grid item md={8}>
            <ControlledTextField
              control={control}
              name="parameters.hybridHeatPump.performanceTableId"
              rules={{ ...validators.required }}
              error={errors.parameters?.hybridHeatPump?.performanceTableId}
              label={t(
                'createProvider.forms.hybridHeatPump.performanceTableId',
              )}
              select
            >
              {performanceTables.map((table) => (
                <MenuItem key={table.id} value={table.id}>
                  {table.name}
                </MenuItem>
              ))}
            </ControlledTextField>
          </Grid>
          <Grid item md={4}>
            <ControlledTextField
              control={control}
              name="parameters.hybridHeatPump.copModifier"
              rules={{
                ...validators.required,
                ...validators.copModifier,
              }}
              defaultValue="1"
              error={errors.parameters?.hybridHeatPump?.copModifier}
              label={t('createProvider.forms.hybridHeatPump.copModifier')}
            />
          </Grid>
        </Grid>
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.hybridHeatPump.heatingPower"
          rules={{
            ...validators.required,
            ...validators.decimal,
          }}
          error={errors.parameters?.hybridHeatPump?.heatingPower}
          label={t('createProvider.forms.hybridHeatPump.heatingPower')}
          InputProps={{
            endAdornment: <Typography>{powerUnit}</Typography>,
          }}
        />
      </FormGroup>

      <FormGroup>
        <Grid container>
          <Grid item md={4}>
            <ControlledCheckbox
              control={control}
              name="parameters.hybridHeatPump.heatSourceAvailable"
              label={t(
                'createProvider.forms.hybridHeatPump.heatSourceAvailable',
              )}
            />
          </Grid>
          <Grid item md={4}>
            <ControlledCheckbox
              control={control}
              name="parameters.hybridHeatPump.heatExhaustAvailable"
              label={t(
                'createProvider.forms.hybridHeatPump.heatExhaustAvailable',
              )}
            />
          </Grid>
          <Grid item md={4}>
            <ControlledCheckbox
              control={control}
              name="parameters.hybridHeatPump.heatRecycleAvailable"
              label={t(
                'createProvider.forms.hybridHeatPump.heatRecycleAvailable',
              )}
            />
          </Grid>
        </Grid>
      </FormGroup>
    </>
  )
}
